import { render } from "./Dashboard.vue?vue&type=template&id=5da03e22&scoped=true"
import script from "../js/dashboard.js?vue&type=script&lang=js"
export * from "../js/dashboard.js?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=5da03e22&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da03e22"]])

export default __exports__